import { InfoComponent } from './info/info.component';
import { HomepagecomponentComponent } from './homepagecomponent/homepagecomponent.component';
import { StatewisecomponentComponent } from './statewisecomponent/statewisecomponent.component';
import { CountrywiseComponent } from './countrywise/countrywise.component';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {CountriwiseindiaComponent} from './countriwiseindia/countriwiseindia.component';

const routes: Routes = [
  {path: '', component: HomepagecomponentComponent},
  {path: 'home', component: HomeComponent},
  {path: 'countries/India', component: CountriwiseindiaComponent},
  {path: 'countries/:id', component: CountrywiseComponent},
  {path: 'state/:id', component: StatewisecomponentComponent},
  {path: '**', component: HomeComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
